<template>
  <div
    class="reward-home"
    :style="styleBackgroundLight"
  >
    <div class="reward-home__column reward-home__column-left">
      <div class="reward-home__wrapper-img">
        <img
          class="reward-home__img"
          :src="reward.image_url"
        >
      </div>
    </div>
    <div class="reward-home__column reward-home__column-right">
      <div
        v-if="false"
        class="reward-home__ribbon"
      >
        <img :src="ribbonPath">
      </div>

      <h6 class="reward-home__name">
        {{ reward.name }}
      </h6>
      <div class="reward-home__refund">
        <div
          class="reward-home__refund-amount"
          :style="styleBackground"
        >
          {{ reward.formatted_amount }}
        </div>
      </div>

      <div
        v-if="specialOffer"
        class="reward-home__end-date"
      >
        Jusqu'au
        <strong :style="styleText">
          {{ formattedEndDate }}
        </strong>
      </div>
      <div
        v-else-if="reward.missing_value === 0"
        class="reward-home__value"
      >
        Pour
        <strong :style="globalStylePrimaryColorText">
          {{ reward.value }}
        </strong>
        points
      </div>
      <div
        v-else
        class="reward-home__missing-points"
        :style="globalStylePrimaryColorText"
      >
        {{ reward.formatted_missing_value }}
      </div>
    </div>
  </div>
</template>

<script>
import MixinPrimaryColor from '~/mixins/primaryColor'
export default {
  mixins: [MixinPrimaryColor],
  props: {
    reward: {
      type: Object,
      required: true,
      validator: reward =>
        reward.hasOwnProperty('name') &&
        reward.hasOwnProperty('image_url') &&
        reward.hasOwnProperty('formatted_amount') &&
        (
          (
            // special offer
            reward.hasOwnProperty('end_date')
          ) || (
            // reward catalog
            reward.hasOwnProperty('missing_value') &&
            reward.missing_value === 0 &&
            reward.hasOwnProperty('value') &&
            reward.hasOwnProperty('formatted_missing_value') &&
            // catalog visible if not connected
            // reward.hasOwnProperty('is_targeted') &&
            // reward.hasOwnProperty('missing_points') &&
            // reward.hasOwnProperty('formatted_missing_points')) &&
            true
          ) || (
            reward.hasOwnProperty('formatted_missing_value')
          )
        )
      ,
    },
    specialOffer: Boolean,
  },
  computed: {
    ribbonPath () {
      if (this.specialOffer) {
        return require('assets/images/icons/icon-ribbon-percent/icon-ribbon-percent.png')
      } else {
        return require('assets/images/icons/icon-ribbon/icon-ribbon.png')
      }
    },
    styleText () {
      if (this.specialOffer) {
        return { color: 'rgba(21, 24, 137, 1)' }
      } else {
        return this.globalStylePrimaryColorText
      }
    },
    styleBackground () {
      if (this.specialOffer) {
        return { backgroundColor: 'rgba(21, 24, 137, 1)' }
      } else {
        return this.globalStylePrimaryColorBackground
      }
    },
    styleBackgroundLight () {
      if (this.specialOffer) {
        return { backgroundColor: 'rgba(21, 24, 137, 0.1)' }
      } else {
        return this.globalStylePrimaryColorBackgroundLight
      }
    },
    formattedEndDate () {
      if (!this.reward.end_date) { return }
      return new Date(this.reward.end_date).toLocaleDateString()
    },
  },
}
</script>

<style scoped>
.reward-home {
  display: flex;
  flex-direction: row;
  font-family: 'Roboto', sans-serif;
  cursor: pointer;
}
.reward-home__column {
  padding: 0.5rem;
}
.reward-home__column-left {
  width: 11rem;
}
.reward-home__wrapper-img {
  width: 10rem;
  height: 10rem;
}
.reward-home__img {
  max-width: 100%;
  max-height: 100%;
}

.reward-home__column-right {
  position: relative;
  width: calc(100% - 11rem);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.reward-home__ribbon {
  position: absolute;
  top: -1px;
  right: 0.5rem;
}

.reward-home__name {
  padding-right: 4rem;
  margin-bottom: 0;
}
.reward-home__refund-amount {
  display: inline-block;
  vertical-align: middle;
  color: white;
  border-radius: 0.5rem;
  padding: 0.2rem 0.5rem;
  text-transform: uppercase;
  font-family: 'Oswald', sans-serif;
}
</style>
